import { Effect, SeratoFilter } from '@/pixi/filters/types'
import { Layers } from '@/static/Layers'
import { Resolution } from '@/types'
import * as PIXI from 'pixi.js'

/**
 * This class represents a layer on the canvas which can be drawn and have effects applied to it.
 * The effects array contains the effects that are currently applied to the layer.
 */
export class CanvasLayer extends PIXI.Container {

  constructor (
    zIndex: Layers,
    resolution: Resolution
  ) {
    super()
    this.zIndex = zIndex
    this.filterArea = new PIXI.Rectangle(0, 0, resolution.width, resolution.height)
  }

  public updateEffects (effects: Effect[]) {
    this.filters = effects.reduce((filters, effect) => filters.concat(effect.filters), [] as SeratoFilter[])
  }

}